module.exports = __webpack_public_path__ + "af67934153e205d003bbea7c6a5cf119.svg";